import { WarehousingSearchService } from 'src/app/features/transport-operation/services/warehousing-search.service';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { CommonDataService } from './../../../../core/services/common-data.service';
import { AdvisingServiceService } from './../../services/advising-service.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, OnInit, Injector } from '@angular/core';
import { LaasOption } from 'src/app/core/models/laas-option';
import { CodeConverterOptions } from 'src/app/core/models/options/code-converter-options';
import { PrimeIcons } from 'primeng/api';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { AdDetailInfoResponse } from 'src/app/core/models/transport-operation/ad-detail-info-response';
import { FacilityService } from 'src/app/core/services/facility.service';
import { QueryWhEventStatusRequest } from 'src/app/core/models/transport-operation/query-whEvent-status-request';
import { InboundTracksStatus } from 'src/app/core/models/transport-operation/inbound-tracks-status';
import { InboundProgressResp } from 'src/app/core/models/transport-operation/inbound-tracks-response';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-inbound-progress',
  templateUrl: './inbound-progress.component.html',
  styleUrls: ['./inbound-progress.component.scss']
})
export class InboundProgressComponent extends SessionBaseComponent implements OnInit {

  readonly viewPermissionCode = PermissionConstants.ViewQueryADStatus;
  readonly preferenceKey: string = UserPreferenceConstants.InboundProgress;
  events: InboundTracksStatus[] = [];
  readonly specialFacilityParamKey: string = "bondedWarehousing";
  specialFacility: string[] = [];
  statusOptions: Array<LaasOption> = [];
  results: AdDetailInfoResponse[] = [];
  columns: DateTableColumn[] = [];
  adNo: string = "adno0001";
  facility: string = "LK";
  orgIdOptions: LaasOption[] = [];
  lockStatusOptions: LaasOption[] = [];
  hawbNo:string = '';
  flag:string = '1';
  whEventParams: QueryWhEventStatusRequest = new QueryWhEventStatusRequest();
  status:string[] = [];
  currentLang: string = this.laasSetting.language;

  constructor(
    injector: Injector,
    private advisingServiceService: AdvisingServiceService,
    private commonDataService: CommonDataService,
    private facilityService: FacilityService,
    private warehousingSearchService: WarehousingSearchService
  ) {
    super(injector);

    this.columns = [
      { field: 'orgId', header: 'InboundProgress.MainTable.Column.OrgId' },
      { field: 'adNo', header: 'InboundProgress.MainTable.Column.AdNo' },
      { field: 'billOfLading', header: 'InboundProgress.MainTable.Column.BillOfLading' },
      { field: 'invoiceNo', header: 'InboundProgress.MainTable.Column.InvoiceNo' },
      { field: 'sku', header: 'InboundProgress.MainTable.Column.Sku' },
      { field: 'expectedQty', header: 'InboundProgress.MainTable.Column.ExpectedQty' },
      { field: 'lockStatus', header: 'InboundProgress.MainTable.Column.LockStatus' },
    ];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.whEventParams.adNo = this.routeStateService.getCurrent().data.adNo;
    this.flag = this.routeStateService.getCurrent().data.flag;
    this.whEventParams.facility = this.routeStateService.getCurrent().data.facility;
    this.whEventParams.hawb = this.routeStateService.getCurrent().data.hawb;
    this.whEventParams.whNo = this.routeStateService.getCurrent().data.whNo;

    let systemValue = await this.commonDataService.getSystemParam(this.specialFacilityParamKey).toPromise();
    if(systemValue.length > 0){
      this.specialFacility = systemValue[0].sn?.split(",");
      console.log(this.specialFacility);
    }
    console.log(this.whEventParams);
    if(this.flag == '1'){
      this.warehousingSearchService.queryWhEventStatusByAd(this.whEventParams).subscribe({
      next: results => {
        console.log(results);
        this.status.push("0-1");
        this.checkStatus(results);
        this.mappingEvent(results);
        this.updateIcon();

        this.advisingServiceService.queryAdDetailInfo(this.whEventParams.adNo).subscribe({
          next: result => {
            this.results = result;
            console.log(results);
          }
        });
      }
      });
    }else{
      this.warehousingSearchService.queryWhEventStatusByWh(this.whEventParams).subscribe({
        next: results => {
          console.log(results);
          this.status.push("0-1");
          this.checkStatus(results);
          this.mappingEvent(results);
          this.results=results.adDetailInfos;
          this.updateIcon();
        }
      });
    }

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "advising").subscribe({
      next: (results: CodeConverterOptions[]) => {
        this.statusOptions = results.map(x => ({ label: x.codeDesc, value: x.codeKey }));
      }
    });


    this.facilityService.getTenantOrgOptions().subscribe({
      next: (options: any[]) => {
        this.orgIdOptions = options.map(x => ({ label: `${x.orgId} - ${x.orgName}`, value: x.orgId}));
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, "DropdownList", "WMSLockStatus").subscribe({
      next: (results: CodeConverterOptions[]) => {
        this.lockStatusOptions = results.map(x => ({ label: `${x.codeKey} - ${x.codeDesc}`, value: x.codeKey }));
      }
    });
  }
  checkStatus(result:InboundProgressResp){
    if(result.import){
      this.status.push("0-2","0-3");
    }
    if(result.showPortClearance){
      this.status.push("0-3-1");
    }
    if(result.feliks){
      this.status.push("0-4","0-5","0-6","0-7");
    }
    this.status.push("1","2","9");
  }

  mappingEvent(result:InboundProgressResp){
    this.events = this.status.map(x => {
      return{
        status: x,
        actualDt: null,
        estimatedDt:null,
        updateReason:"　",
        isShowUpdateReason:false,
        percent:"0%"
      }
    });
    if(!isNullOrEmpty(result.events)){
      result.events.forEach(x => {
        this.events.forEach(event => {
          if(x.status === event.status){
            event.actualDt = x.actualDt;
            event.estimatedDt = x.estimatedDt;
            event.updateReason = x.updateReason;
            event.percent = x.percent;
            event.isShowUpdateReason = !isNullOrEmpty(event.updateReason);
          }
        });
      });
    }
  }

  updateIcon(): void{
    this.events.forEach((value, index) => {
      if(!isNullOrEmpty(value.actualDt)){
        value.icon = PrimeIcons.CHECK;
        value.color = '#FF8B85';
      }else{
        value.icon = 'far fa-cicle';
        value.color = '#ccc';
      }
    });
  }

}
